import { FUNCTION_CREATION, FUNCTION_UPDATE } from 'utils/toastDispacher';
import { getBotspecInfo } from 'data/selectors';
import { saveBotSpec } from '../chatbots';

const saveFunction = (functionKey, data) => (dispatch, getState) => {
  const { botspec } = getBotspecInfo(getState());
  const { spec_json: specJson } = botspec;
  const { functions: specFunctions } = specJson;
  const functionExist = specFunctions[functionKey];
  const newFunctions = {
    ...specFunctions,
    [functionKey]: {
      ...specFunctions[functionKey],
      ...data,
    },
  };
  const newBotspec = {
    ...botspec,
    spec_json: {
      ...botspec.spec_json,
      functions: newFunctions,
    },
  };
  dispatch(saveBotSpec(newBotspec, {
    actionId: functionExist ? FUNCTION_UPDATE : FUNCTION_CREATION,
    elementName: functionKey,
  }));
};

export default saveFunction;
